//@import dependencies
import React, {useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import "react-datepicker/dist/react-datepicker.css";
import { store } from 'app_storage/redux-storage';

import EditorJS from 'react-editor-js'
// @ts-ignore
import Embed from '@editorjs/embed'
// @ts-ignore
import Header from '@editorjs/header'
// @ts-ignore
import Image from '@editorjs/image'
// @ts-ignore
import LinkE from '@editorjs/link'
// @ts-ignore
import List from '@editorjs/list'
// @ts-ignore
import Paragraph from '@editorjs/paragraph'
// @ts-ignore
import Raw from '@editorjs/raw'
// @ts-ignore
import Checklist from '@editorjs/checklist'
//@end

// @import configs
import { external_api } from 'app_config/globals';
// @end

//@import components
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../modalContentFormModule.scss'

const Quote = require('@editorjs/quote');
const Table = require('@editorjs/table')

// @ADD Component types
interface IModalContentFormModuleLayoutProps {
  open          : boolean
  processing    : boolean
  customErrors? : any
  editData?     : any
  handleClose   : (data:any)=>void
  onHandleSubmit: (data: any) => void
}

const ModalContentFormModuleLayout: React.FC<IModalContentFormModuleLayoutProps> = (props) => {

  const storeObject = store

  // @INFO: Services
  const [colors] = useColors()

  const exampleData = {
    blocks: [{
      type: 'header',
      data: {
        text: 'Sin titulo',
        level: 2
      }
    }],
    time: new Date().getTime(),
    version: '2.19.0'
  }

  const {open} = props

  const [editorDataData, updateEditorDataData] = useState<undefined | any>(null)

  const formHook = useForm()
  const { t } = useTranslation()

  const handleCloseModal = (data: any) => {
    props.handleClose(data)
  }

  /**
   * @INFO Referencia del cambio del editor
   * @param data
   */
   const handleChangeEditor = (api: any, data?: any) => {
    if(data){
      let dataToSave = exampleData
      if (data.blocks && data.blocks.length > 0) {
        dataToSave = data
      }
      switch (api) {
        case 'data':
          updateEditorDataData(dataToSave)
          break;
        default:
          break;
      }
    }
  }

  // Configuración del editor
  const EDITOR_TOOLS = {
    embed: {
      class: Embed,
      inlineToolbar: true
    },
    header: {
      class: Header,
      inlineToolbar: true
    },
    image: {
      class: Image,
      config: {
        endpoints: {
          byFile: `${external_api.backend.url}/api/admin/editor-js/image/upload-by-file`,
          byUrl: `${external_api.backend.url}/api/admin/editor-js/image/upload-by-url`
        },
        additionalRequestHeaders: {
          'Authorization': storeObject.getState().auth.user?.token ? storeObject.getState().auth.user?.token : ''
        },
        additionalRequestData: {
          // id: responseAPI ? responseAPI.academic_resource : ''
        }
      }
    },
    linkTool: {
      class: LinkE,
      config: {
        endpoint: `${external_api.backend.url}/api/admin/editor-js/link/fetch-url`
      }
    },
    quote: {
      class: Quote,
      inlineToolbar: true,
      shortcut: 'CMD+SHIFT+O',
      config: {
        quotePlaceholder: 'Enter a quote',
        captionPlaceholder: 'Quote\'s author',
      },
    },
    paragraph: {
      class: Paragraph,
      inlineToolbar: true
    },
    list: {
      class: List,
      inlineToolbar: true
    },
    raw: {
      class: Raw,
      inlineToolbar: true
    },
    checklist: {
      class: Checklist,
      inlineToolbar: true
    },
    table: {
      class: Table,
      inlineToolbar: true
    },
  }

  useEffect(() => {
    if (props?.editData) {
      updateEditorDataData((props?.editData?.data) ? props?.editData?.data : exampleData)
    } else {
      updateEditorDataData(exampleData)
    }
  }, [props,props.editData])

  return(
    <div className=''>
      <Modal show={open} onHide={() => handleCloseModal({ status: false })} className="modal_content_form-component">
        <Modal.Header>
          <Modal.Title>
            {t('modules.modal_content_form.title')}
          </Modal.Title>
          <div className="close-button" onClick={() => handleCloseModal({status: false})}>
            <IconComponent
              color={colors.secondary}
              width='1.5rem'
              height='1.5rem'
              fontawesome={{
                icon: 'fas fa-times-circle',
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>

            {props?.editData?.uuid && (
              <input
                type="hidden"
                name="uuid"
                defaultValue={props?.editData?.uuid}
                ref={formHook.register({ required: true })}
              />
            )}

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='name'>{t('labels.modal_content_form.name')}</label>
                {formHook.errors.name && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='name'
                  name='name'
                  className={`form-control ${formHook.errors.name && 'is-invalid'}`}
                  // type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={(props?.editData?.name) ? props?.editData?.name : ''}
                />
              </div>
            </div>

            {/* <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='data'>{t('labels.modal_content_form.data')}</label>
                {formHook.errors.data && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <textarea
                  id='data'
                  name='data'
                  className={`form-control ${formHook.errors.data && 'is-invalid'}`}
                  // type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={(props?.editData?.data) ? props?.editData?.data : ''}
                />
              </div>
            </div> */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='data'>{t('labels.modal_content_form.data')}</label>
                <input
                  id="data"
                  type="hidden"
                  name="data"
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.data}
                  value={(editorDataData) ? JSON.stringify(editorDataData) : ''}
                />
                {editorDataData && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataData}
                    onChange={(api: any, data?: any) => handleChangeEditor('data', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.data && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className='buttons-group'>
              <div className='text-center'>
                <button className='btn btn-secondary' type='submit' disabled={props.processing}>
                  {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                  {t('modules.modal_content_form.form.save')}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ModalContentFormModuleLayout
